import { Button } from "@/components/ui/button";
import { useEffect, useRef } from "react";
import useTranslation from "next-translate/useTranslation";

export default function LeagueWelcome({ onClose }: { onClose: () => void }) {
  const { t } = useTranslation("puzzles");
  const dialog = useRef<HTMLDialogElement>(null);
  useEffect(() => {
    dialog.current?.showModal();
    return () => dialog.current?.close();
  }, []);
  return (
    <dialog
      ref={dialog}
      onCancel={(event) => {
        event.preventDefault();
        onClose();
      }}
      aria-labelledby="puzzle-welcome-title"
      className="w-[calc(100%_-_2rem)] max-w-sm rounded-xl bg-white p-7 text-slate-900 shadow-xl backdrop:bg-black/40"
    >
      <Button
        variant="quiet"
        size="icon"
        type="button"
        className="absolute right-3 top-3"
        onClick={onClose}
        aria-label={t("league.closeWelcome")}
      >
        ×
      </Button>
      <h2 id="puzzle-welcome-title" className="pr-3 text-2xl font-semibold">
        {t("league.welcomeTitle")}
      </h2>
      <p className="mt-4 text-base leading-7 text-slate-600">
        {t("league.welcomeText")}
      </p>
      <Button autoFocus onClick={onClose} size="lg" className="mt-6 w-full">
        {t("league.startSolving")}
      </Button>
    </dialog>
  );
}
